<template>
  <div class="GoodsItem">
    <div class="item-box van-hairline--bottom" @click.stop="link(data.id)">
      <i class="btn btn-check" @click.stop="check" :class="data.isCheck&&'active'"></i>
      <div class="goods-info">
        <p class="goods-name">{{ data.name }}</p>
        <p class="goods-price">
          <span>￥</span>
          <span>{{ price }}</span>
        </p>
      </div>
      <i class="btn btn-collection" @click.stop="collection" :class="data.isFavorite&&'active'"></i>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import { scaleNum } from '@/utils/utils'

export default {
  name: "GoodsItem",
  components: {},
  props: ["data", "index"],
  data() {
    return {};
  },
  computed: {
    price(){
      return scaleNum(this.data.oldPrice, -2)
    },
    orderList() {
      return this.$store.getters.orderList
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    link(id) {
      this.$router.push({
        path:'/item',
        query: {
          id: id
        }
      })
    },
    check() {
      if (this.orderList.filter(cartItem => cartItem.labId !== this.data.labId).length > 0) {
        this.$toast('不支持跨实验室下单')
        return
      }
      if (this.data.isCheck) {
        this.$store.commit('removeCartItem', this.data)
      } else {
        this.$store.commit('addCartItem', this.data)
      }
      this.$emit('_check', this.index)
    },
    collection() {
      this.$emit('_collection', this.index)
    },
  },
};
</script>

<style lang="scss" scoped>
.GoodsItem {
  background: #fff;
  padding: 0 24px;

  .item-box {
    display: flex;
    align-items: center;
    //justify-content: space-between;
    padding: 0 24px;

    .btn {
      width: 32px;
      height: 32px;
      background-size: 100% 100%;
      flex-shrink: 0;
    }

    .btn-check {
      background-image: url("../../assets/btn-check.png");
      margin-right: 30px;
    }

    .btn-check.active {
      background-image: url("../../assets/btn-check-active.png");
    }

    .btn-collection {
      background-image: url("../../assets/btn-collection.png");
    }

    .btn-collection.active {
      background-image: url("../../assets/btn-collection-active.png");
    }

    .goods-info {
      text-align: left;
      margin-right: auto;
      padding: 24px 0 32px;

      .goods-name {
        color: #333;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
      }

      .goods-price {
        color: #21AEC3;
        font-size: 32px;
        line-height: 40px;
        margin-top: 10px;

        > span:first-child {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
